import { AiIrbAdminLinkDef } from '../types';

export const AI_IRB_ADMIN_LINKS: readonly AiIrbAdminLinkDef[] = [
  { label: 'Agent Registry', path: '/admin/registry', gate: 'admin' },
  // Available to internal staff only.
  { label: 'Chat monitoring', path: '/chat-monitoring', gate: 'internal' },
  { label: 'Review types', path: '/admin/review-types', gate: 'admin' },
  {
    label: 'Publish surveys to eRM',
    path: '/admin/erm-publish',
    gate: 'admin',
  },
  { label: 'Knowledgebases', path: '/admin/knowledge-bases', gate: 'admin' },
];
